
<template>

  <ArticleLayout class="GlossaryEntry"
    :backLink="{ path: context.indexPagePath, text: localeStrings.returnToIndex[content._type] }"
    :pageContent="content"
    v-bind="{ segment, relatedItemsContent }"
  >

    <template v-slot:header>
      <ArticleHeading class="heading">{{ content.title }}</ArticleHeading>
    </template>

    <template v-slot:body="{ pageCta }">
      <ArticleBody class="body" :blocks="content.body" v-bind="{ pageCta }" />
    </template>

  </ArticleLayout>

</template>

<script>
import { extraContentQueryFragment } from './article/ArticleLayout.vue'
import { articlePreviewQueryFragment } from './shared/ArticlePreview.vue'

export const contentQuery = `
  *[_id == $pageId][0]{
    _type,
    locale,
    title,
    body,
    "relatedResourceLinks":
      *[
        _type == ^._type &&
        locale == ^.locale &&
        _id != ^._id &&
        defined(slug)
      ]
      | order(date desc)
      [0..3]
      ${articlePreviewQueryFragment},
    ${extraContentQueryFragment}
  }
`
</script>

<script setup>
import { provide } from 'vue'
import strings from './strings.json'

import ArticleBody from './article/ArticleBody.vue'
import ArticleHeading from './article/ArticleHeading.vue'
import ArticleLayout from './article/ArticleLayout.vue'

import { getRelatedItemsContent } from './lib/article-util'

const { content, context } = defineProps({ content: Object, context: Object })

const localeStrings = strings[content.locale]

provide('locale', content.locale)
provide('localeStrings', localeStrings)
provide('context', context)

const segment = { 'glossary5gItem': '5g', 'glossaryFleetItem': 'fleet' }[content._type]
const relatedItemsContent = getRelatedItemsContent(content, context.indexPagePath)
</script>

<style scoped>
.body {
  margin-top: var(--spacing-11);
}
</style>
